const isMainnet = process.env.IS_MAINNET == "true";
export const ERC20_TOKEN_ADDRESS = isMainnet ? '0x9663677b81c2d427e81c01ef7315ea96546f5bb1' : '0x6134609813b143c7292D38a8064Dbe0D2C41411C';
